<template>
  <div>
    <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
      <div v-for="(item, index) in list" :key="index" class="Item"  @click="toChat(item.roleInfo.roleId)">
        <div style="position: relative;">
          <img :src="item.roleInfo.avatarUrl" class="avatar"/>
          <div v-if="item.activeStatus===1" class="activeStatus"></div>
        </div>
        <div class="info">
          <div class="line">
            <div class="name">{{ item.roleInfo.roleName }}</div>
            <div class="orderStatus" v-if="item.orderStatus">{{ getOrderStatus(item.orderStatus) }}</div>
            <div class="greet">打招呼</div>
          </div>
          <div class="message">{{ item.text }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>

import {Dialog, List} from "vant";
import Vue from "vue";

Vue.use(Dialog)
    .use(List)

import {listOnline,getRoomId,createRoom} from "@/api/clerk/chat-room";

export default {
  name: "roomList",
  components: {},

  computed: {
    time: () => {
      return (val) => {
        let now = new Date()
        let nowYear = now.getFullYear()
        let nowMonth = now.getMonth() < 9 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
        let nowDay = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
        let dateStr = `${nowYear}-${nowMonth}-${nowDay}`
        let todayDateTime = new Date(dateStr).getTime()
        let yesterday = todayDateTime - (24 * 60 * 60 * 1000)
        let beforeDay = todayDateTime - (48 * 60 * 60 * 1000)
        if (val > todayDateTime) { //当天
          let date = new Date(val);
          let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          return hour + ':' + minute
        } else if (val < todayDateTime && val > yesterday) {
          return '昨天'
        } else if (val < yesterday && val > beforeDay) {
          return '前天'
        } else { //更早之前
          let date = new Date(val);
          let year = date.getFullYear();
          let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          if (year == nowYear) {
            return month + '月' + day + '日'
          } else {
            return year + '年' + month + '月' + day + '日'
          }
        }
      }
    }
  },

  data() {
    return {
      pageSize: 15,
      cursor: null,
      loading: false,
      finished: false,
      list: [],
      roomRoleInfoMap: new Map(),
    }
  },

  methods: {
    toChat(userId) {
      this.getRoomId(userId).then((roomId) => {
          this.$router.push({
            path: '/clerk/chat/roomInfo',
            query: {
              id: roomId,
            }
          })
      })
    },
    createRoom(userId) {
      return new Promise((resolve) => {
        // 第一个方法的代码
        createRoom({
          userId: userId,
        }).then(res => {
          const data = res.data;
          if (data.code == 0) {
            this.id=data.roomId
            resolve(data.roomId);
          } else {
            Dialog.alert({title: '获取房间号失败', message: data.msg})
          }
        })
      });
    },
    getRoomId(userId) {
      return new Promise((resolve) => {
        // 第一个方法的代码
        getRoomId({
          userId: userId
        }).then(res => {
          const data = res.data;
          if (data.code == 0) {
            if (data.roomId){
              this.id=data.roomId
              resolve(data.roomId);
            }else {
              this.createRoom(userId).then((id) => {
                resolve(id);
              })
            }
          } else {
            Dialog.alert({title: '获取房间号失败', message: data.msg})
          }
        })
      });
    },
    getOrderStatus(status){
      switch (status){
        case 0: return "待接单";
        case 1: return "待服务";
        case 2: return "服务中";
        case 3: return "已完成";
        case 4: return "已取消";
        default :
          return "";
      }
    },

    onLoad(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.cursor = null
        this.positionType = false
        this.list = [];
      } else {
        this.positionType = true
      }
      this.loading = true
      listOnline({
        cursor: this.cursor,
        pageSize: this.pageSize,
      }).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.cursorPage.list)
          this.cursor = data.cursorPage.cursor
          if (data.cursorPage.isLast) {//是否是最后一页
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      }).catch(res =>{
        this.finished = true
        Dialog.alert({
          title: '加载失败',
        })
      })
    },
  },
}


</script>

<style scoped lang="less">
.list {

  .Item {
    display: flex;
    align-items: center;
    padding: 4vw 5.07vw;

    .avatar {

      width: 13.9vw;
      height: 13.9vw;
      border-radius: 50%;
    }
    .activeStatus{
      position: absolute;
      width: 2.4vw;
      height: 2.4vw;
      background: #24E877;
      border-radius: 50%;
      bottom: 0.5vw;
      right: 0.9vw;
      border: 0.4vw solid #FFFFFF;
    }

    .info {
      flex: 1;
      margin-left: 4.83vw;

      .line {
        display: flex;
        align-items: center;
        margin-bottom: 1.81vw;

        .name {
          font-size: 4vw;
          font-weight: bold;
          margin-right: 3.2vw;
        }
        .orderStatus{
          background-color: #B687FC;
          border-radius: 4px;
          color: #ffffff;
          font-size: 10px;
          padding: 1px 3px;
        }
        .greet {
          width: 18vw;
          height: 8.4vw;
          line-height: 8.4vw;
          margin-left: auto;
          border:1px #B687FC solid;
          box-sizing: border-box;
          border-radius: 222px;
          color: #B687FC;
          font-size: 3.5vw;
          text-align: center;

        }
      }

      .message {
        color: #858584;
        font-size: 3.12vw;

      }
    }
  }
}
</style>
